import { FunctionComponent, useState } from 'react';
import {  FormHelperText, TextField, Typography } from '@mui/material';
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';
import ApiKeyService from '../../../shared/services/api-key/api-key.service';
import { IApiKey } from '../../../shared/services/api-key/api-key.model';

export const CreateApiKeyDialog: FunctionComponent<{
  open: boolean;
  closeHandler: () => void;
  successHandler: (createdKey: IApiKey) => void;
}> = ({ open, closeHandler, successHandler }) => {
  const apiKeyService = new ApiKeyService();

  const [details, setDetails] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const handleSubmit = () => {
    setIsSubmitting(true);
    setError('');
    apiKeyService.create({ details: details || undefined })
      .then(response => {
        setIsSubmitting(false);
        setDetails('');
        successHandler(response);
      })
      .catch(err => {
        setIsSubmitting(false);
        setError('There was an error creating the API key, please try again.');
        console.log(err);
      });
  };

  const handleClose = () => {
    setDetails('');
    setError('');
    closeHandler();
  };

  return (
    <DialogWrapper
      open={open}
      onClose={handleClose}
      title='Create API Key'
      cancelHandler={handleClose}
      submitHandler={handleSubmit}
      isSubmitting={isSubmitting}
    >
      <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
        Optionally provide a description to identify this key.
      </Typography>
      <TextField
        fullWidth
        label='Description (optional)'
        value={details}
        onChange={(e) => setDetails(e.target.value)}
        disabled={isSubmitting}
        placeholder='e.g. Production integration'
        sx={{ mt: 1 }}
      />
      {error && (
        <FormHelperText sx={{ color: '#bf3333', mt: 1 }}>{error}</FormHelperText>
      )}
    </DialogWrapper>
  );
};
